// import { useState } from 'react';
import type { ReactNode } from 'react';
import { Outlet } from 'react-router-dom';
import { experimentalStyled, Theme } from '@material-ui/core/styles';
// import useDrawer from '../../hooks/useDrawer';
import MiniDrawer from './miniDrawer';

interface DashboardLayoutProps {
  children?: ReactNode;
}

const DashboardLayoutRoot = experimentalStyled('div')(
  ({ theme }) => (
    {
      backgroundColor: theme.palette.background.default,
      display: 'flex',
      height: '100vh',
      overflow: 'hidden',
      width: '100%'
    }
  )
);

const DashboardLayoutWrapper = experimentalStyled('div')(
  ({ theme }: { theme?: Theme }) => (
    {
      display: 'flex',
      flex: '1 1 auto',
      // overflow: 'hidden',
      paddingTop: '50px',
      [theme.breakpoints.up('lg')]: {
        paddingLeft: '0px'
      }
    }
  )
);

const DashboardLayoutContainer = experimentalStyled('div')({
  display: 'flex',
  flex: '1 1 auto',
  overflow: 'hidden'
});

const DashboardLayoutContent = experimentalStyled('div')({
  flex: '1 1 auto',
  height: '100%',
  overflow: 'auto',
  position: 'relative',
  // WebkitOverflowScrolling: 'touch'
});

const DashboardLayout: React.FC<DashboardLayoutProps> = () => {
  // const { drawerOpen } = useDrawer();
  // const handleClickClose = () => {
  //   closeDrawerInButton();
  // };
  return (
    <DashboardLayoutRoot>
      <MiniDrawer />
      <DashboardLayoutWrapper>
        <DashboardLayoutContainer>
          <DashboardLayoutContent>
            <Outlet />
          </DashboardLayoutContent>
        </DashboardLayoutContainer>
      </DashboardLayoutWrapper>
    </DashboardLayoutRoot>
  );
};

export default DashboardLayout;
